import { render, staticRenderFns } from "./GSDataNewsItem.vue?vue&type=template&id=65d20a6b&scoped=true&"
import script from "./GSDataNewsItem.vue?vue&type=script&lang=js&"
export * from "./GSDataNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./GSDataNewsItem.vue?vue&type=style&index=0&id=65d20a6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d20a6b",
  null
  
)

export default component.exports